import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["onClick", "className"],
    _excluded2 = ["onClick", "className"],
    _excluded3 = ["children", "className"],
    _excluded4 = ["title", "subtitle", "className"];
import { jsx, jsxs } from 'react/jsx-runtime';
import { XMark, PointerChevronLeft } from '@box/blueprint-web-assets/icons/Fill';
import clsx from 'clsx';
import { forwardRef, useCallback } from 'react';
import { Text } from '../../text/text.js';
import { composeEventHandlers } from '../../utils/composeEventHandlers.js';
import { IconButton } from '../icon-button/icon-button.js';
import { useFullScreenDropdownMenu } from '../menu-utils/responsiveness/FullScreenDropdownMenuContext.js';
import { useSubMenu } from '../menu-utils/responsiveness/SubMenuContext.js';
import styles from './dropdown-menu.module.js';
var MenuCloseButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var onClick = _ref.onClick,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useFullScreenDropdow = useFullScreenDropdownMenu(),
      setIsMenuOpen = _useFullScreenDropdow.setIsMenuOpen;

  var handleCloseClick = useCallback(function () {
    setIsMenuOpen(false);
  }, [setIsMenuOpen]);
  return jsx(IconButton, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    className: clsx(styles.menuCloseButton, className),
    icon: XMark,
    onClick: composeEventHandlers(handleCloseClick, onClick),
    variant: "small-utility"
  }));
});
var SubMenuBackButton = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var onClick = _ref2.onClick,
      className = _ref2.className,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  var _useSubMenu = useSubMenu(),
      setIsSubMenuOpen = _useSubMenu.setIsSubMenuOpen;

  var handleCloseClick = useCallback(function () {
    setIsSubMenuOpen(false);
  }, [setIsSubMenuOpen]);
  return jsx(IconButton, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    className: clsx(styles.submenuCloseButton, className),
    icon: PointerChevronLeft,
    onClick: composeEventHandlers(handleCloseClick, onClick)
  }));
});

var MenuHeaderPrimitive = function MenuHeaderPrimitive(_ref3) {
  var children = _ref3.children,
      className = _ref3.className,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  return jsx("div", _objectSpread(_objectSpread({}, rest), {}, {
    className: clsx(styles.menuHeader, className),
    role: "presentation",
    children: children
  }));
};

var TextContent = /*#__PURE__*/forwardRef(function (_ref4, ref) {
  var title = _ref4.title,
      subtitle = _ref4.subtitle,
      className = _ref4.className,
      rest = _objectWithoutProperties(_ref4, _excluded4);

  return jsxs("div", _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    className: clsx(className, styles.headerTextContent),
    children: [jsx(Text, {
      as: "span",
      className: styles.ellipsis,
      variant: "bodyLargeBold",
      children: title
    }), subtitle && jsx(Text, {
      as: "span",
      className: styles.ellipsis,
      color: "textOnLightSecondary",
      variant: "caption",
      children: subtitle
    })]
  }));
});
var DropdownMenuHeader = Object.assign(MenuHeaderPrimitive, {
  MenuCloseButton: MenuCloseButton,
  SubMenuBackButton: SubMenuBackButton,
  TextContent: TextContent
});
export { DropdownMenuHeader };